export default "__VITE_ASSET__Cve64dfN__"